import {
  subMonths,
  lastDayOfMonth,
  isAfter,
  isBefore,
  isEqual,
  startOfMonth,
  addYears,
} from "date-fns";
import Personnummer from "personnummer";

export const isPersonalNumberValid = (personalNumber: string) => {
  try {
    if (typeof personalNumber === "string" && personalNumber.length > 0) {
      const isValid = Personnummer.valid(personalNumber);
      return isValid;
    } else {
      return false;
    }
  } catch {
    return false;
  }
};

export const getPersonAge = (personalNumber: string): number | null => {
    try {
      let instance = new Personnummer(personalNumber);
      const age = instance.getAge();
      return age
    } catch {
      return null
    }
}

export const isYoungEnough = (personalNumber: string) => {
  const AGE_LIMIT = 66;

  try {
    let instance = new Personnummer(personalNumber);
    const age = instance.getAge();

    if (age >= AGE_LIMIT) {
      return false;
    } else if (age === AGE_LIMIT - 1) {
      const today = new Date();
      const firstDayOfMonth = startOfMonth(today);

      // in JS Date January = 0 so we have subtract on month to be correct
      const birth = new Date(
        parseInt(instance.fullYear),
        parseInt(instance.month) - 1,
        parseInt(instance.day)
      );

      const cutOffDate = addYears(birth, AGE_LIMIT);

      // A person is able to join up until the month they have their birthday
      const lastAllowedDate = lastDayOfMonth(subMonths(cutOffDate, 1));

      // Check if we have passed the allowed month or just on it
      if (
        isAfter(firstDayOfMonth, lastAllowedDate) ||
        isEqual(firstDayOfMonth, lastAllowedDate)
      ) {
        return false;
      } else if (isBefore(firstDayOfMonth, lastAllowedDate)) {
               return true;
             }
    }
    return true;
  } catch {
    return true;
  }
};
